import React, { useEffect, useState } from "react"
import Skeleton from "react-loading-skeleton"
import "react-loading-skeleton/dist/skeleton.css"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { Container, Row, Col, Input, Button, Label } from "reactstrap"
import { toast } from "react-toastify"
import axios from "axios"

const BookingRadiusSetting = () => {
  const [rideHailingRadius, setRideHailingRadius] = useState(10)
  const [otherRidesRadius, setOtherRidesRadius] = useState(10)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = localStorage.getItem("authToken")
        const response = await axios.get(
          `${process.env.REACT_APP_WEB_APP_URL}/api/web/booking-settings`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        if (response.status === 200 && response.data?.data) {
          setRideHailingRadius(response.data.data.ride_hailing_radius_km ?? 10)
          setOtherRidesRadius(response.data.data.other_rides_radius_km ?? 10)
        }
      } catch (error) {
        console.error(error)
        toast.error("Failed to load booking settings")
      } finally {
        setLoading(false)
      }
    }

    fetchData()
  }, [])

  const handleSave = async () => {
    try {
      const token = localStorage.getItem("authToken")
      const body = {
        ride_hailing_radius_km: Number(rideHailingRadius),
        other_rides_radius_km: Number(otherRidesRadius),
      }
      const response = await axios.post(
        `${process.env.REACT_APP_WEB_APP_URL}/api/web/booking-settings`,
        body,
        {
          headers: {
            "Content-type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      )
      if (response.status === 200) {
        toast.success("Booking radius settings updated", { autoClose: 3000 })
        // refresh values after save
        try {
          const refresh = await axios.get(
            `${process.env.REACT_APP_WEB_APP_URL}/api/web/booking-settings`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          )
          if (refresh.status === 200 && refresh.data?.data) {
            setRideHailingRadius(refresh.data.data.ride_hailing_radius_km ?? 10)
            setOtherRidesRadius(refresh.data.data.other_rides_radius_km ?? 10)
          }
        } catch (e) {
          // ignore refresh failure; values are already saved
        }
      } else {
        toast.error("Failed to update booking settings", { autoClose: 3000 })
      }
    } catch (error) {
      console.error(error)
      toast.error(error?.response?.data?.message || "Failed to update booking settings", { autoClose: 3000 })
    }
  }

  document.title = "Booking Radius Settings | Moeen"

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Breadcrumbs title="Home" breadcrumbItem="Booking Radius Settings" />
        {loading ? (
          <Skeleton count={10} height={40} />
        ) : (
          <div className="page-content">
            <Container fluid>
              <Row>
                <Col>
                  <h4 className="mb-5">Booking Radius (Km)</h4>
                </Col>
              </Row>

              <Row className="align-items-center mb-4">
                <Col md={4}>
                  <Label>Ride hailing radius (Taxi)</Label>
                  <Input
                    value={rideHailingRadius}
                    className="border-black"
                    onChange={e => setRideHailingRadius(e.target.value)}
                    type="number"
                    min={1}
                  />
                </Col>
              </Row>

              <Row className="align-items-center mb-5">
                <Col md={4}>
                  <Label>Other rides radius (Towing / Waste / Industrial)</Label>
                  <Input
                    value={otherRidesRadius}
                    className="border-black"
                    onChange={e => setOtherRidesRadius(e.target.value)}
                    type="number"
                    min={1}
                  />
                </Col>
              </Row>

              <Row>
                <Col className="text-end mt-5">
                  <Button
                    onClick={() => {
                      setRideHailingRadius(10)
                      setOtherRidesRadius(10)
                    }}
                    color="success"
                    outline
                    className="me-3 px-4"
                  >
                    Cancel
                  </Button>
                  <Button onClick={handleSave} color="success" className="px-4">
                    Save
                  </Button>
                </Col>
              </Row>
            </Container>
          </div>
        )}
      </div>
    </div>
  )
}

export default BookingRadiusSetting

